export class DomEvents {
    public static readonly Blur = 'blur';
    public static readonly Change = 'change';
    public static readonly Click = 'click';
    public static readonly Focus = 'focus';
    public static readonly Hover = 'hover';
    public static readonly Input = 'input';
    public static readonly KeyDown = 'keydown';
    public static readonly KeyPress = 'keypress';
    public static readonly KeyUp = 'keyup';
    public static readonly MouseLeave = 'mouseleave';
    public static readonly MouseEnter = 'mouseenter';
    public static readonly MouseOut = 'mouseout';
    public static readonly MouseOver = 'mouseover';
    public static readonly Submit = 'submit';
}
